// extracted by mini-css-extract-plugin
module.exports = {"stepper":"Stepper_stepper__BvRiS","step":"Stepper_step__1k0C7","stepText":"Stepper_stepText__31FVM","selected":"Stepper_selected__NiRZ2","completed":"Stepper_completed__m3JCM"};